// src/components/layout/AdminLayout.js — admin shell matching SettingsLayout:
// persistent left rail with grouped destinations, content pane via <Outlet/>.
// Mobile collapses the rail into a horizontal chip row above the content.
import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { ShieldCheckIcon, NewspaperIcon, TicketIcon, ChartBarIcon } from '@heroicons/react/24/outline';

const GROUPS = [
    {
        label: 'General',
        items: [
            { to: '/admin', label: 'Dashboard', Icon: ShieldCheckIcon, end: true },
            { to: '/admin/content-manager', label: 'Manage Content', Icon: NewspaperIcon },
        ],
    },
    {
        label: 'Billing',
        items: [
            { to: '/admin/coupons', label: 'Coupons', Icon: TicketIcon },
            { to: '/admin/cancellation-feedback', label: 'Cancellation Feedback', Icon: ChartBarIcon },
        ],
    },
];

const itemClass = ({ isActive }) =>
    `flex items-center gap-3 rounded-lg px-4 py-2.5 text-sm transition-colors ${
        isActive
            ? 'bg-white/10 text-white font-medium'
            : 'text-neutral-400 hover:bg-white/5 hover:text-white'
    }`;

const AdminLayout = () => (
    <div className="px-4 py-8 sm:py-12 text-white">
        <div className="mx-auto flex max-w-7xl flex-col gap-8 lg:flex-row">
            <aside className="shrink-0 lg:w-64">
                <h1 className="mb-6 hidden px-4 text-2xl font-bold tracking-tight lg:block">Admin</h1>
                <nav className="flex gap-2 overflow-x-auto pb-2 lg:flex-col lg:gap-6 lg:overflow-visible lg:pb-0">
                    {GROUPS.map((group) => (
                        <div key={group.label} className="flex gap-2 lg:block">
                            <div className="mb-2 hidden px-4 text-[11px] font-semibold uppercase tracking-[0.18em] text-neutral-500 lg:block">
                                {group.label}
                            </div>
                            <div className="flex gap-2 lg:flex-col lg:gap-1">
                                {group.items.map(({ to, label, Icon, end }) => (
                                    <NavLink key={to} to={to} end={end} className={itemClass}>
                                        <Icon className="h-5 w-5 shrink-0" />
                                        <span className="whitespace-nowrap">{label}</span>
                                    </NavLink>
                                ))}
                            </div>
                        </div>
                    ))}
                </nav>
            </aside>
            <div className="min-w-0 flex-1">
                <Outlet />
            </div>
        </div>
    </div>
);

export default AdminLayout;
